import FormField from './FormField';
import { getInstance } from '@/i18n';

export default class FormFieldInfo extends FormField
{
    getDisplayedValue()
    {
        if(this.getDefinedValueLabel() !== null)
        {
            return this.getDefinedValueLabel();
        }

        if(this.getDefinedValue() !== null)
        {
            return this.getDefinedValue();
        }

        const val = this.getValue();
        const tkey = `parameters.${this.getCode()}.values.${val}.label`;
        const i18n = getInstance();

        if(i18n.global.te(tkey))
        {
            return i18n.global.t(tkey);
        }

        if(val === null)
        {
            return null;
        }

        return this.formatValue(val);
    }
}
